import React from 'react'
import { FiMessageCircle } from "react-icons/fi";
import { BsTelephone } from "react-icons/bs";
import { BiLock } from 'react-icons/bi';

export default function Options({ options, setOptions, banned, toggleOpen, clearTrigger }) {

    if (banned) {
        return (
            <div className='options-banned'>
                <BiLock className='options-lock' />
            </div>
        );
    }

    return (
        <div className='options' onClick={toggleOpen ? () => toggleOpen(prevState => !prevState) : () => {return}}>
            {/**<FiHome className='options-home' onClick={() => setOptions(1)} />*/}
            <FiMessageCircle className={`options-icon ${options === 0 ? 'selected' : ''}`} onClick={() => { clearTrigger(); setOptions(0); }} />
            <BsTelephone className={`options-icon ${options === 1 ? 'selected' : ''}`} onClick={() => { clearTrigger(); setOptions(1); }} />
        </div>
    )
}
